import { IconButtonDatatable } from "App/Component/ui";
import { TableRow } from "@material-ui/core";
import React from "react";
import { useDatatables } from "App/hooks";
import { TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { SelectIcon } from "App/Assets";
import { FreezeTableClient } from "components/organism";
import { defaultDateDisplay, today, dateTimePickerToValidDate } from "App/utils/helpers";
import { getTanggalRujukanPlus89Hari } from "../helpers"

const TableListMultiNoRujukan = ({ rows = [], handleClickSelect }) => {
  return (
    <TableListMultiRujukanContainer
      rows={rows}
      handleClickSelect={handleClickSelect}
    />
  );
};

const TableListMultiRujukanContainer = ({ rows, handleClickSelect }) => {
  const {
    page,
    setPage,
    setRowsPerPage,
    order,
    orderBy,
    length,
    handleRequestSort,
    rowsPerPage,
    setQ,
    data,
  } = useDatatables({
    rows: rows,
    orderByDefault: "tglKunjungan",
    orderByRow: ["noKunjungan"],
  });

  return (
    <>
      <FreezeTableClient
        title="Daftar No Rujukan"
        setQ={setQ}
        maxHeight="300px"
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            const tanggalRujukanPlus90Hari = getTanggalRujukanPlus89Hari(row.tglKunjungan);
            const isRujukanHabis = dateTimePickerToValidDate(tanggalRujukanPlus90Hari, false) < today();

            const tanggalRujukan = defaultDateDisplay(row?.tglKunjungan, false, false);
            const tanggalHabisRujukan = defaultDateDisplay(tanggalRujukanPlus90Hari, false);

            const upperHemodialisa = row.poliRujukan?.nama.toUpperCase();
            const isHemodialisa = upperHemodialisa === "HEMODIALISA";

            const styleCell = () => {
              if (isHemodialisa) {
                return undefined;
              }

              if (isRujukanHabis) {
                return { color: "white" };
              } else {
                return undefined;
              }
            };

            const backgroundConditional = () => {
              if (isHemodialisa) {
                return "inherit";
              }

              if (isRujukanHabis) {
                return "#fca5a5";
              } else {
                return "inherit";
              }
            };

            const colorConditional = () => {
              if (isHemodialisa) {
                return "inherit";
              }

              if (isRujukanHabis) {
                return "white";
              } else {
                return "inherit";
              }
            };

            return (
              <TableRow
                hover
                key={row.name}
                style={{
                  background: backgroundConditional(),
                  color: colorConditional(),
                }}
              >
                <TableCell align="center" style={styleCell()}>
                  {index + 1}
                </TableCell>

                <TableCell align="center">
                  {(!isRujukanHabis || isHemodialisa) && (
                    <IconButtonDatatable
                      color="secondary"
                      aria-label="delete"
                      onClick={() => handleClickSelect(row)}
                      style={{
                        background: "#D8D8D8",
                        borderRadius: "8px",
                        padding: "6px",
                      }}
                    >
                      <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                    </IconButtonDatatable>
                  )}
                </TableCell>
                <TableCell style={styleCell()}>{row?.noKunjungan}</TableCell>
                <TableCell style={styleCell()}>{tanggalRujukan}</TableCell>
                <TableCell style={styleCell()}>{tanggalHabisRujukan}</TableCell>
                <TableCell style={styleCell()}>{row?.pelayanan?.nama}</TableCell>
                <TableCell style={styleCell()}>{row?.peserta?.nama}</TableCell>
                <TableCell style={styleCell()}>{row?.poliRujukan?.nama}</TableCell>
              </TableRow>
            );
          })}
      </FreezeTableClient>
    </>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "noKunjungan",
    disablePadding: true,
    label: "NO KUNJUNGAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },

  {
    id: "tglKunjungan",
    disablePadding: true,
    label: "TGL KUNJUNGAN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },

  {
    id: "tglHabisRujukan",
    disablePadding: true,
    label: "TGL HABIS RUJUKAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },

  {
    id: "jnsPelayanan",
    disablePadding: true,
    label: "JENIS",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nama",
    disablePadding: true,
    label: "NAMA",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "poliRujukan",
    disablePadding: true,
    label: "POLI RUJUKAN",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
];

export default TableListMultiNoRujukan;
